<template>
  <div class="container">
    <PublicHeader :totalName="$t('property').IncomeDetails" />
    <!-- 列表 -->
    <div class="listInfo">
      <van-list v-model="loading" :finished="finished" :loading-text="$t('public').loadingText" @load="getOrderList"
        :immediate-check="false">
        <div class="item" v-for="(dItem, dIndex) in oList" :key="`po${dIndex}`">
          <div class="name"> {{ dItem.productName }} <span class="amount red" v-if="dItem.profitAmount < 0">-${{
            -dItem.profitAmount }}</span>
            <span class="amount green" v-else>+${{ dItem.profitAmount }}</span>
          </div>
          <div class="time">{{ dItem.createTime | getLocalTime }} <span>-</span> <span>{{ dItem.salesTime | getLocalTime
              }}</span></div>
          <div class="order" v-if="dItem.orderNo">{{ dItem.orderNo }} <span @click="onCopy(dItem.orderNo)">{{
            $t('public').copyTxt }}</span>
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
import PublicHeader from '@/components/publicHeader'
import orderApi from '@/api/order'
export default {
  components: {
    PublicHeader
  },
  data() {
    return {
      isRun: false,
      loading: false,
      finished: false,
      parms: {
        pageNum: 1,
        pageSize: 15,
      },
      oList: [],
    }
  },
  mounted() {
    this.getOrderList()
  },
  methods: {
    // 获取平仓订单列表
    async getOrderList() {
      if (this.isRun) return
      this.isRun = true
      this.parms.status = '3'
      const res = await orderApi.getOrderList(this.parms)
      this.oList.push(...res.rows);
      this.isRun = false
      this.parms.pageNum++
      // 加载状态结束
      this.loading = false;
      // 数据全部加载完成
      if (this.oList.length >= res.total)
        this.finished = true;
    },
    //复制方法
    onCopy(text) {
      return new Promise((resolve) => {
        if (navigator.clipboard?.writeText) {
          this.$toast(this.$t('public').copySuccess)
          return resolve(navigator.clipboard.writeText(text))
        }
        const textarea = document.createElement('textarea')
        document.body.appendChild(textarea)
        textarea.style.position = 'absolute'
        textarea.style.clip = 'rect(0 0 0 0)'
        textarea.value = text
        textarea.select()
        document.execCommand('copy', true)
        textarea.remove()
        this.$toast(this.$t('public').copySuccess)
        return resolve(true)
      })
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  width: 100%;
  padding: 50px 15px 15px 15px;
  background: var(--background_color);

  .listInfo {

    .item {
      padding: 15px;
      background: var(--info_color);
      border-radius: 10px;
      margin-top: 15px;

      .name {
        display: flex;
        justify-content: space-between;
        font-size: 16px;
        color: var(--text_color);
      }

      .time {
        margin-top: 10px;
        font-size: 12px;
        color: #64748B;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      .order {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 10px;
        font-size: 12px;
        color: #64748B;

        span {
          color: var(--primary_color);
        }
      }
    }
  }

}
</style>
